if (!customElements.get('phc-simple-bundle-picker')) {
  customElements.define('phc-simple-bundle-picker', class extends HTMLElement {
    static focusTargets = new Map();

    connectedCallback() {
      if (this.initialized) return;
      this.select = this.querySelector('[data-phc-native-select]');
      if (!this.select) return;
      this.entries = Array.from(this.select.options).map(option => {
        const parts = option.value.split(':');
        const lengths = (parts.at(-1).match(/\d+/g) || []).map(Number);
        const count = parts.length > 1 ? Number(parts[0].match(/\d+/)?.[0]) : lengths.length;
        if (!count || lengths.length !== count) return null;
        return {
          option: option.cloneNode(true),
          value: option.value,
          count,
          lengths,
          mode: lengths.every(length => length === lengths[0]) ? 'same' : 'mixed',
          available: !option.disabled,
        };
      });
      if (!this.entries.length || this.entries.some(entry => !entry)) return;
      this.current = this.entries.find(entry => entry.value === this.select.value);
      if (!this.current) return;
      this.initialized = true;
      this.render(this.current);
      this.querySelector('.phc-simple-bundle-picker__controls').hidden = false;
      this.addEventListener('click', event => this.onChoice(event));
      this.select.addEventListener('change', () => {
        this.current = this.entries.find(entry => entry.value === this.select.value);
        this.updateSummary();
        this.constructor.focusTargets.set(this.dataset.sectionId, this.select.id);
      });
      const focusId = this.constructor.focusTargets.get(this.dataset.sectionId);
      if (focusId) {
        this.constructor.focusTargets.delete(this.dataset.sectionId);
        requestAnimationFrame(() => {
          const target = document.getElementById(focusId);
          if (target && this.contains(target) && !target.closest('[hidden]')) target.focus({ preventScroll: true });
        });
      }
    }

    onChoice(event) {
      const button = event.target.closest('[data-bundle-count], [data-bundle-mode]');
      if (!button || !this.contains(button) || button.disabled) return;
      const count = Number(button.dataset.bundleCount || this.current.count);
      const requestedMode = button.dataset.bundleMode || this.current.mode;
      const candidates = this.entries.filter(entry => entry.count === count);
      let pool = candidates.filter(entry => entry.mode === requestedMode);
      if (!pool.length) pool = candidates;
      const available = pool.filter(entry => entry.available);
      if (available.length) pool = available;
      const next = pool.find(entry => entry.value === this.current.value)
        || pool.find(entry => entry.lengths[0] === this.current.lengths[0])
        || pool.reduce((closest, entry) => !closest || Math.abs(entry.lengths[0] - this.current.lengths[0]) < Math.abs(closest.lengths[0] - this.current.lengths[0]) ? entry : closest, null);
      if (!next || next.value === this.current.value) return;
      this.render(next);
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.constructor.focusTargets.set(this.dataset.sectionId, button.id);
    }

    render(entry) {
      this.current = entry;
      const pool = this.entries.filter(item => item.count === entry.count && item.mode === entry.mode);
      const options = pool.map(item => {
        const option = item.option.cloneNode(true);
        option.removeAttribute('selected');
        if (item.value === entry.value) option.setAttribute('selected', 'selected');
        option.textContent = this.lengthText(item) + (item.available ? '' : ` — ${this.dataset.soldOut}`);
        return option;
      });
      this.select.replaceChildren(...options);
      this.select.value = entry.value;
      this.querySelectorAll('[data-bundle-count]').forEach(button => {
        const count = Number(button.dataset.bundleCount);
        button.hidden = !this.entries.some(item => item.count === count);
        button.setAttribute('aria-pressed', String(count === entry.count));
      });
      const modes = new Set(this.entries.filter(item => item.count === entry.count).map(item => item.mode));
      this.querySelector('.phc-simple-bundle-picker__modes').hidden = modes.size < 2;
      this.querySelectorAll('[data-bundle-mode]').forEach(button => {
        button.hidden = !modes.has(button.dataset.bundleMode);
        button.setAttribute('aria-pressed', String(button.dataset.bundleMode === entry.mode));
      });
      const preset = pool.length === 1;
      this.querySelector('[data-length-select-wrap]').hidden = preset;
      const label = this.querySelector('[data-length-label]');
      label.textContent = preset ? this.dataset.includedLabel : entry.mode === 'mixed' ? this.dataset.lengthsLabel : this.dataset.lengthLabel;
      const presetText = this.querySelector('[data-preset]');
      presetText.hidden = !preset;
      presetText.textContent = this.fullLengths(entry);
      this.updateSummary();
    }

    fullLengths(entry) {
      return entry.lengths.map(length => `${length}″`).join(' + ');
    }

    lengthText(entry) {
      return entry.mode === 'same' && entry.count > 1 ? `${entry.lengths[0]}″ ${this.dataset.each}` : this.fullLengths(entry);
    }

    updateSummary() {
      const summary = this.querySelector('[data-selection-summary]');
      summary.hidden = false;
      const template = this.current.count === 1 ? this.dataset.summaryOne : this.dataset.summary;
      summary.querySelector('[data-selection-lengths]').textContent = template.replace('[count]', this.current.count).replace('[lengths]', this.fullLengths(this.current));
      summary.querySelector('[data-selection-weight]').textContent = this.dataset.weightSummary.replace('[weight]', this.current.count * 100);
    }
  });
}

